var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-wrapper"},[_c('div',{staticClass:"loading-animation"},[_c('lottie',{attrs:{"options":_vm.options}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('LOADING_LABEL')))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }